"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeHostHeader = exports.normalizeHost = exports.membershipMarkets = exports.marketLanguageSupport = exports.domainURL = exports.domainLanguages = exports.defaultMarkets = exports.SupportedLanguagesArray = exports.SupportedLanguages = exports.SupportedLanguageList = exports.DefaultCurrencyForMarket = void 0;
var _config = _interopRequireDefault(require("next/config"));
var _ref = (0, _config["default"])() || {},
  publicRuntimeConfig = _ref.publicRuntimeConfig;
var defaultDomainURLs = {
  tr: 'https://www.enuygun.com',
  us: 'https://www.wingie.com',
  gb: 'https://www.wingie.co.uk',
  de: 'https://www.wingie.de',
  es: 'https://www.wingie.es',
  ae: 'https://www.wingie.ae',
  sa: 'https://sa.wingie.com',
  ru: 'https://ru.wingie.com',
  eg: 'https://eg.wingie.com',
  kw: 'https://kw.wingie.com',
  om: 'https://om.wingie.com',
  bh: 'https://bh.wingie.com',
  jo: 'https://jo.wingie.com',
  qa: 'https://www.wingie.qa',
  pk: 'https://www.wingie.pk',
  "in": 'https://www.wingie.co.in',
  kz: 'https://kz.wingie.com',
  uz: 'https://uz.wingie.com',
  tj: 'https://tj.wingie.com',
  kg: 'https://kg.wingie.com',
  lb: 'https://lb.wingie.com',
  ca: 'https://ca.wingie.com',
  au: 'https://au.wingie.com',
  nz: 'https://nz.wingie.com',
  za: 'https://za.wingie.com',
  at: 'https://at.wingie.com',
  ch: 'https://ch.wingie.com',
  iq: 'https://iq.wingie.com',
  ma: 'https://ma.wingie.com',
  ge: 'https://ge.wingie.com',
  mx: 'https://mx.wingie.com',
  az: 'https://www.wingie.az',
  pl: 'https://www.wingie.pl',
  it: 'https://www.wingie.it',
  fr: 'https://www.wingie.fr'
};
var domainURL = exports.domainURL = function (_process, _publicRuntimeConfig$) {
  var raw = ((_process = process) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.DOMAIN_URLS) || (publicRuntimeConfig === null || publicRuntimeConfig === void 0 || (_publicRuntimeConfig$ = publicRuntimeConfig.processEnv) === null || _publicRuntimeConfig$ === void 0 ? void 0 : _publicRuntimeConfig$.NEXT_PUBLIC_DOMAIN_URLS);
  if (!raw || raw === 'undefined') {
    return defaultDomainURLs;
  }
  try {
    return JSON.parse(raw);
  } catch (e) {
    console.error('Failed to parse DOMAIN_URLS, using defaults', e);
    return defaultDomainURLs;
  }
}();

/** X-Forwarded-Host bazen path içerir (örn. www.wingie.az/ru); domain eşlemesi için yalnızca hostname. */
var sanitizeHostHeader = exports.sanitizeHostHeader = function sanitizeHostHeader(host) {
  var _trimmed$split$;
  if (host == null) return null;
  var trimmed = String(host).trim();
  if (!trimmed) return null;
  try {
    if (trimmed.includes('://')) {
      var withScheme = /^https?:\/\//i.test(trimmed) ? trimmed : "https://".concat(trimmed);
      return new URL(withScheme).hostname;
    }
  } catch (_unused) {
    /* ignore */
  }
  // port'u at (www.wingie.pl:6008 → www.wingie.pl); IPv6 köşeli parantez desteklenmez (prod host'lar hostname)
  var beforeSlash = (_trimmed$split$ = trimmed.split('/')[0]) === null || _trimmed$split$ === void 0 ? void 0 : _trimmed$split$.trim();
  if (!beforeSlash) return null;
  if (beforeSlash.startsWith('[')) return beforeSlash;
  return beforeSlash.split(':')[0] || beforeSlash;
};

// Staging domain'lerini production domain'lerine map eden fonksiyon
var normalizeHost = exports.normalizeHost = function normalizeHost(host) {
  var sanitized = sanitizeHostHeader(host);
  if (!sanitized) return null;
  if (sanitized === 'staging.wingie.com' || sanitized.includes('staging.wingie.com')) {
    return 'www.wingie.com';
  }
  return sanitized;
};
var domainLanguages = exports.domainLanguages = {
  us: 'en',
  gb: 'en',
  de: 'de',
  es: 'es',
  ae: 'ar',
  sa: 'ar',
  ru: 'ru',
  eg: 'ar',
  kw: 'ar',
  om: 'ar',
  bh: 'ar',
  jo: 'ar',
  qa: 'ar',
  pk: 'en',
  "in": 'en',
  tr: 'tr',
  kz: 'ru',
  uz: 'ru',
  tj: 'ru',
  kg: 'ru',
  lb: 'ar',
  ca: 'en',
  au: 'en',
  nz: 'en',
  za: 'en',
  at: 'de',
  ch: 'de',
  iq: 'ar',
  ma: 'ar',
  ge: 'ru',
  mx: 'es',
  az: 'az',
  pl: 'pl',
  it: 'it',
  fr: 'fr'
};
var defaultMarkets = exports.defaultMarkets = {
  en: 'us',
  de: 'de',
  es: 'es',
  ar: 'ae',
  ru: 'ru',
  tr: 'tr',
  az: 'az',
  it: 'it',
  fr: 'fr',
  pt: 'us',
  ro: 'us',
  pl: 'pl',
  lt: 'us',
  uz: 'us',
  sr: 'us',
  ky: 'us',
  tg: 'us',
  kk: 'us',
  nl: 'us',
  zh: 'us',
  ka: 'ge',
  hi: 'in',
  ja: 'us',
  ko: 'us',
  ur: 'pk',
  ta: 'in',
  th: 'us'
};
var membershipMarkets = exports.membershipMarkets = ['tr', 'sa', 'ae', 'eg', 'us', 'kw', 'jo', 'qa', 'pk', 'in', 'bh', 'gb', 'de', 'es', 'ru', 'om', 'mx', 'kz', 'uz', 'tj', 'kg', 'lb', 'ca', 'au', 'iq', 'ma', 'ge', 'pl', 'it', 'fr', 'az'];
var SupportedLanguageList = exports.SupportedLanguageList = ['tr-tr', 'az-az', 'az-ru', 'az-de', 'az-es', 'az-ar', 'az-en', 'az-it', 'az-fr', 'az-pt', 'az-ro', 'az-pl', 'az-lt', 'az-uz', 'az-sr', 'az-ky', 'az-tg', 'az-kk', 'az-nl', 'az-zh', 'az-ka', 'az-hi', 'az-ja', 'az-ko', 'az-ur', 'az-ta', 'az-th',
// US Market
'us-en', 'us-ar', 'us-ru', 'us-de', 'us-es', 'us-it', 'us-fr', 'us-pt', 'us-ro', 'us-pl', 'us-lt', 'us-uz', 'us-sr', 'us-ky', 'us-tg', 'us-kk', 'us-nl', 'us-az',
// GB Market
'gb-en', 'gb-ar', 'gb-ru', 'gb-de', 'gb-es', 'gb-it', 'gb-fr', 'gb-pt', 'gb-ro', 'gb-pl', 'gb-lt', 'gb-uz', 'gb-sr', 'gb-ky', 'gb-tg', 'gb-kk', 'gb-nl', 'gb-az',
// DE Market
'de-de', 'de-ar', 'de-ru', 'de-en', 'de-es', 'de-it', 'de-fr', 'de-pt', 'de-ro', 'de-pl', 'de-lt', 'de-uz', 'de-sr', 'de-ky', 'de-tg', 'de-kk', 'de-nl', 'de-az',
// ES Market
'es-es', 'es-ar', 'es-ru', 'es-de', 'es-en', 'es-it', 'es-fr', 'es-pt', 'es-ro', 'es-pl', 'es-lt', 'es-uz', 'es-sr', 'es-ky', 'es-tg', 'es-kk', 'es-nl', 'es-az',
// AE Market
'ae-ar', 'ae-ru', 'ae-de', 'ae-en', 'ae-es', 'ae-it', 'ae-fr', 'ae-pt', 'ae-ro', 'ae-pl', 'ae-lt', 'ae-uz', 'ae-sr', 'ae-ky', 'ae-tg', 'ae-kk', 'ae-nl', 'ae-az',
// SA Market
'sa-ar', 'sa-ru', 'sa-de', 'sa-en', 'sa-es', 'sa-it', 'sa-fr', 'sa-pt', 'sa-ro', 'sa-pl', 'sa-lt', 'sa-uz', 'sa-sr', 'sa-ky', 'sa-tg', 'sa-kk', 'sa-nl', 'sa-az',
// RU Market
'ru-ru', 'ru-ar', 'ru-de', 'ru-en', 'ru-es', 'ru-it', 'ru-fr', 'ru-pt', 'ru-ro', 'ru-pl', 'ru-lt', 'ru-uz', 'ru-sr', 'ru-ky', 'ru-tg', 'ru-kk', 'ru-nl', 'ru-az',
// EG Market
'eg-ar', 'eg-ru', 'eg-de', 'eg-en', 'eg-es', 'eg-it', 'eg-fr', 'eg-pt', 'eg-ro', 'eg-pl', 'eg-lt', 'eg-uz', 'eg-sr', 'eg-ky', 'eg-tg', 'eg-kk', 'eg-nl', 'eg-az',
// KW Market
'kw-ar', 'kw-ru', 'kw-de', 'kw-en', 'kw-es', 'kw-it', 'kw-fr', 'kw-pt', 'kw-ro', 'kw-pl', 'kw-lt', 'kw-uz', 'kw-sr', 'kw-ky', 'kw-tg', 'kw-kk', 'kw-nl', 'kw-az',
// OM Market
'om-ar', 'om-ru', 'om-de', 'om-en', 'om-es', 'om-it', 'om-fr', 'om-pt', 'om-ro', 'om-pl', 'om-lt', 'om-uz', 'om-sr', 'om-ky', 'om-tg', 'om-kk', 'om-nl', 'om-az',
// BH Market
'bh-ar', 'bh-ru', 'bh-de', 'bh-en', 'bh-es', 'bh-it', 'bh-fr', 'bh-pt', 'bh-ro', 'bh-pl', 'bh-lt', 'bh-uz', 'bh-sr', 'bh-ky', 'bh-tg', 'bh-kk', 'bh-nl', 'bh-az',
// JO Market
'jo-ar', 'jo-ru', 'jo-de', 'jo-en', 'jo-es', 'jo-it', 'jo-fr', 'jo-pt', 'jo-ro', 'jo-pl', 'jo-lt', 'jo-uz', 'jo-sr', 'jo-ky', 'jo-tg', 'jo-kk', 'jo-nl', 'jo-az',
// QA Market
'qa-ar', 'qa-ru', 'qa-de', 'qa-en', 'qa-es', 'qa-it', 'qa-fr', 'qa-pt', 'qa-ro', 'qa-pl', 'qa-lt', 'qa-uz', 'qa-sr', 'qa-ky', 'qa-tg', 'qa-kk', 'qa-nl', 'qa-az',
// PK Market
'pk-en', 'pk-ar', 'pk-ru', 'pk-de', 'pk-es', 'pk-it', 'pk-fr', 'pk-pt', 'pk-ro', 'pk-pl', 'pk-lt', 'pk-uz', 'pk-sr', 'pk-ky', 'pk-tg', 'pk-kk', 'pk-nl', 'pk-az',
// IN Market
'in-en', 'in-ar', 'in-ru', 'in-de', 'in-es', 'in-it', 'in-fr', 'in-pt', 'in-ro', 'in-pl', 'in-lt', 'in-uz', 'in-sr', 'in-ky', 'in-tg', 'in-kk', 'in-nl', 'in-az',
// KZ Market
'kz-ru', 'kz-ar', 'kz-de', 'kz-en', 'kz-es', 'kz-it', 'kz-fr', 'kz-pt', 'kz-ro', 'kz-pl', 'kz-lt', 'kz-uz', 'kz-sr', 'kz-ky', 'kz-tg', 'kz-kk', 'kz-nl', 'kz-az',
// UZ Market
'uz-ru', 'uz-ar', 'uz-de', 'uz-en', 'uz-es', 'uz-it', 'uz-fr', 'uz-pt', 'uz-ro', 'uz-pl', 'uz-lt', 'uz-uz', 'uz-sr', 'uz-ky', 'uz-tg', 'uz-kk', 'uz-nl', 'uz-az',
// TJ Market
'tj-ru', 'tj-ar', 'tj-de', 'tj-en', 'tj-es', 'tj-it', 'tj-fr', 'tj-pt', 'tj-ro', 'tj-pl', 'tj-lt', 'tj-uz', 'tj-sr', 'tj-ky', 'tj-tg', 'tj-kk', 'tj-nl', 'tj-az',
// KG Market
'kg-ru', 'kg-ar', 'kg-de', 'kg-en', 'kg-es', 'kg-it', 'kg-fr', 'kg-pt', 'kg-ro', 'kg-pl', 'kg-lt', 'kg-uz', 'kg-sr', 'kg-ky', 'kg-tg', 'kg-kk', 'kg-nl', 'kg-az',
// LB Market
'lb-ar', 'lb-ru', 'lb-de', 'lb-en', 'lb-es', 'lb-it', 'lb-fr', 'lb-pt', 'lb-ro', 'lb-pl', 'lb-lt', 'lb-uz', 'lb-sr', 'lb-ky', 'lb-tg', 'lb-kk', 'lb-nl', 'lb-az',
// CA Market
'ca-en', 'ca-ar', 'ca-ru', 'ca-de', 'ca-es', 'ca-it', 'ca-fr', 'ca-pt', 'ca-ro', 'ca-pl', 'ca-lt', 'ca-uz', 'ca-sr', 'ca-ky', 'ca-tg', 'ca-kk', 'ca-nl', 'ca-az',
// AU Market
'au-en', 'au-ar', 'au-ru', 'au-de', 'au-es', 'au-it', 'au-fr', 'au-pt', 'au-ro', 'au-pl', 'au-lt', 'au-uz', 'au-sr', 'au-ky', 'au-tg', 'au-kk', 'au-nl', 'au-az',
// MX Market
'mx-es', 'mx-ar', 'mx-ru', 'mx-de', 'mx-en', 'mx-it', 'mx-fr', 'mx-pt', 'mx-ro', 'mx-pl', 'mx-lt', 'mx-uz', 'mx-sr', 'mx-ky', 'mx-tg', 'mx-kk', 'mx-nl', 'mx-az',
// IQ Market
'iq-ar', 'iq-ru', 'iq-de', 'iq-en', 'iq-es', 'iq-it', 'iq-fr', 'iq-pt', 'iq-ro', 'iq-pl', 'iq-lt', 'iq-uz', 'iq-sr', 'iq-ky', 'iq-tg', 'iq-kk', 'iq-nl', 'iq-az',
// MA Market
'ma-ar', 'ma-ru', 'ma-de', 'ma-en', 'ma-es', 'ma-it', 'ma-fr', 'ma-pt', 'ma-ro', 'ma-pl', 'ma-lt', 'ma-uz', 'ma-sr', 'ma-ky', 'ma-tg', 'ma-kk', 'ma-nl', 'ma-az',
// GE Market
'ge-ru', 'ge-ar', 'ge-de', 'ge-en', 'ge-es', 'ge-it', 'ge-fr', 'ge-pt', 'ge-ro', 'ge-pl', 'ge-lt', 'ge-uz', 'ge-sr', 'ge-ky', 'ge-tg', 'ge-kk', 'ge-nl', 'ge-zh', 'ge-ka', 'ge-hi', 'ge-ja', 'ge-ko', 'ge-ur', 'ge-ta', 'ge-th', 'ge-az',
// US Market - 8 yeni dil
'us-zh', 'us-ka', 'us-hi', 'us-ja', 'us-ko', 'us-ur', 'us-ta', 'us-th',
// GB Market - 8 yeni dil
'gb-zh', 'gb-ka', 'gb-hi', 'gb-ja', 'gb-ko', 'gb-ur', 'gb-ta', 'gb-th',
// DE Market - 8 yeni dil
'de-zh', 'de-ka', 'de-hi', 'de-ja', 'de-ko', 'de-ur', 'de-ta', 'de-th',
// ES Market - 8 yeni dil
'es-zh', 'es-ka', 'es-hi', 'es-ja', 'es-ko', 'es-ur', 'es-ta', 'es-th',
// AE Market - 8 yeni dil
'ae-zh', 'ae-ka', 'ae-hi', 'ae-ja', 'ae-ko', 'ae-ur', 'ae-ta', 'ae-th',
// SA Market - 8 yeni dil
'sa-zh', 'sa-ka', 'sa-hi', 'sa-ja', 'sa-ko', 'sa-ur', 'sa-ta', 'sa-th',
// RU Market - 8 yeni dil
'ru-zh', 'ru-ka', 'ru-hi', 'ru-ja', 'ru-ko', 'ru-ur', 'ru-ta', 'ru-th',
// EG Market - 8 yeni dil
'eg-zh', 'eg-ka', 'eg-hi', 'eg-ja', 'eg-ko', 'eg-ur', 'eg-ta', 'eg-th',
// KW Market - 8 yeni dil
'kw-zh', 'kw-ka', 'kw-hi', 'kw-ja', 'kw-ko', 'kw-ur', 'kw-ta', 'kw-th',
// OM Market - 8 yeni dil
'om-zh', 'om-ka', 'om-hi', 'om-ja', 'om-ko', 'om-ur', 'om-ta', 'om-th',
// BH Market - 8 yeni dil
'bh-zh', 'bh-ka', 'bh-hi', 'bh-ja', 'bh-ko', 'bh-ur', 'bh-ta', 'bh-th',
// JO Market - 8 yeni dil
'jo-zh', 'jo-ka', 'jo-hi', 'jo-ja', 'jo-ko', 'jo-ur', 'jo-ta', 'jo-th',
// QA Market - 8 yeni dil
'qa-zh', 'qa-ka', 'qa-hi', 'qa-ja', 'qa-ko', 'qa-ur', 'qa-ta', 'qa-th',
// PK Market - 8 yeni dil
'pk-zh', 'pk-ka', 'pk-hi', 'pk-ja', 'pk-ko', 'pk-ur', 'pk-ta', 'pk-th',
// IN Market - 8 yeni dil
'in-zh', 'in-ka', 'in-hi', 'in-ja', 'in-ko', 'in-ur', 'in-ta', 'in-th',
// KZ Market - 8 yeni dil
'kz-zh', 'kz-ka', 'kz-hi', 'kz-ja', 'kz-ko', 'kz-ur', 'kz-ta', 'kz-th',
// UZ Market - 8 yeni dil
'uz-zh', 'uz-ka', 'uz-hi', 'uz-ja', 'uz-ko', 'uz-ur', 'uz-ta', 'uz-th',
// TJ Market - 8 yeni dil
'tj-zh', 'tj-ka', 'tj-hi', 'tj-ja', 'tj-ko', 'tj-ur', 'tj-ta', 'tj-th',
// KG Market - 8 yeni dil
'kg-zh', 'kg-ka', 'kg-hi', 'kg-ja', 'kg-ko', 'kg-ur', 'kg-ta', 'kg-th',
// LB Market - 8 yeni dil
'lb-zh', 'lb-ka', 'lb-hi', 'lb-ja', 'lb-ko', 'lb-ur', 'lb-ta', 'lb-th',
// CA Market - 8 yeni dil
'ca-zh', 'ca-ka', 'ca-hi', 'ca-ja', 'ca-ko', 'ca-ur', 'ca-ta', 'ca-th',
// AU Market - 8 yeni dil
'au-zh', 'au-ka', 'au-hi', 'au-ja', 'au-ko', 'au-ur', 'au-ta', 'au-th',
// MX Market - 8 yeni dil
'mx-zh', 'mx-ka', 'mx-hi', 'mx-ja', 'mx-ko', 'mx-ur', 'mx-ta', 'mx-th',
// IQ Market - 8 yeni dil
'iq-zh', 'iq-ka', 'iq-hi', 'iq-ja', 'iq-ko', 'iq-ur', 'iq-ta', 'iq-th',
// MA Market - 8 yeni dil
'ma-zh', 'ma-ka', 'ma-hi', 'ma-ja', 'ma-ko', 'ma-ur', 'ma-ta', 'ma-th',
// şimdilik kullanmıyoruz (Endesign'da var)
// NZ Market - 'nz-en', 'nz-ar', 'nz-ru', 'nz-de', 'nz-es', 'nz-it', 'nz-fr', 'nz-pt', 'nz-ro', 'nz-pl', 'nz-lt', 'nz-uz', 'nz-sr', 'nz-ky', 'nz-tg', 'nz-kk', 'nz-nl'
// ZA Market - 'za-en', 'za-ar', 'za-ru', 'za-de', 'za-es', 'za-it', 'za-fr', 'za-pt', 'za-ro', 'za-pl', 'za-lt', 'za-uz', 'za-sr', 'za-ky', 'za-tg', 'za-kk', 'za-nl'
// AT Market - 'at-de', 'at-ar', 'at-ru', 'at-en', 'at-es', 'at-it', 'at-fr', 'at-pt', 'at-ro', 'at-pl', 'at-lt', 'at-uz', 'at-sr', 'at-ky', 'at-tg', 'at-kk', 'at-nl'
// CH Market - 'ch-de', 'ch-ar', 'ch-ru', 'ch-en', 'ch-es', 'ch-it', 'ch-fr', 'ch-pt', 'ch-ro', 'ch-pl', 'ch-lt', 'ch-uz', 'ch-sr', 'ch-ky', 'ch-tg', 'ch-kk', 'ch-nl'
// PL Market
'pl-ar', 'pl-de', 'pl-en', 'pl-es', 'pl-ru', 'pl-it', 'pl-fr', 'pl-pt', 'pl-ro', 'pl-pl', 'pl-lt', 'pl-uz', 'pl-sr', 'pl-ky', 'pl-tg', 'pl-kk', 'pl-nl', 'pl-zh', 'pl-ka', 'pl-hi', 'pl-ja', 'pl-ko', 'pl-ur', 'pl-ta', 'pl-th', 'pl-az',
// IT Market
'it-ar', 'it-de', 'it-en', 'it-es', 'it-ru', 'it-it', 'it-fr', 'it-pt', 'it-ro', 'it-pl', 'it-lt', 'it-uz', 'it-sr', 'it-ky', 'it-tg', 'it-kk', 'it-nl', 'it-zh', 'it-ka', 'it-hi', 'it-ja', 'it-ko', 'it-ur', 'it-ta', 'it-th', 'it-az',
// FR Market
'fr-ar', 'fr-de', 'fr-en', 'fr-es', 'fr-ru', 'fr-it', 'fr-fr', 'fr-pt', 'fr-ro', 'fr-pl', 'fr-lt', 'fr-uz', 'fr-sr', 'fr-ky', 'fr-tg', 'fr-kk', 'fr-nl', 'fr-zh', 'fr-ka', 'fr-hi', 'fr-ja', 'fr-ko', 'fr-ur', 'fr-ta', 'fr-th', 'fr-az'];
var SupportedLanguagesArray = exports.SupportedLanguagesArray = ['ar', 'de', 'en', 'es', 'ru', 'tr', 'az', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'];
var SupportedLanguages = exports.SupportedLanguages = {
  'tr-tr': 'tr',
  'us-de': 'de',
  'us-ar': 'ar'
};
var DefaultCurrencyForMarket = exports.DefaultCurrencyForMarket = {
  us: 'USD',
  ae: 'AED',
  sa: 'SAR',
  de: 'EUR',
  eg: 'EGP',
  gb: 'GBP',
  ru: 'RUB',
  tr: 'TRY',
  es: 'EUR',
  kw: 'KWD',
  om: 'OMR',
  bh: 'BHD',
  jo: 'JOD',
  qa: 'QAR',
  pk: 'PKR',
  "in": 'INR',
  kz: 'KZT',
  uz: 'UZS',
  tj: 'TJS',
  kg: 'KGS',
  lb: 'LBP',
  ca: 'CAD',
  au: 'AUD',
  iq: 'IQD',
  ma: 'MAD',
  ge: 'GEL',
  // şimdilik kullanmıyoruz
  // nz: 'NZD',
  // za: 'ZAR',
  // at: 'EUR',
  // ch: 'CHF',
  mx: 'MXN',
  az: 'AZN',
  pl: 'PLN',
  it: 'EUR',
  fr: 'EUR'
};

// (NAPI display-settings ile uyumlu)
var marketLanguageSupport = exports.marketLanguageSupport = {
  us: ['ar', 'de', 'en', 'es', 'ru', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  ae: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  sa: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  eg: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  ru: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  de: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  es: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  gb: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  kw: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  bh: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  jo: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  qa: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  pk: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  "in": ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  om: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  kz: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  uz: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  tj: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  kg: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  lb: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  au: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  ca: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  mx: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  iq: ['ar', 'de', 'es', 'ru', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  ma: ['ar', 'de', 'es', 'ru', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  ge: ['ru', 'ar', 'de', 'es', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  // şimdilik kullanmıyoruz
  // nz: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  // za: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  // at: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  // ch: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  tr: ['tr', 'en', 'ar', 'ru'],
  az: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'az', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  pl: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  it: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th'],
  fr: ['de', 'es', 'ru', 'ar', 'en', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th']
};